module.exports = require('./block');

module.exports.BlockHeader = require('./blockheader');
module.exports.MerkleBlock = require('./merkleblock');



//////////////////
// WEBPACK FOOTER
// ./node_modules/bitcoincashjs/src/block/index.js
// module id = mCKI
// module chunks = 0